import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { InstrumentPrijsHistorie } from '../dto/instrument-prijs-historie';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class InstrumentPrijsHistorieService extends CrudService<InstrumentPrijsHistorie> {

    constructor(injector: Injector) { super(InstrumentPrijsHistorie, injector); }

}
